export const API_BASE_URL = '';

/** Fired after issue resolve/close so header badge and notification panel refetch. */
export const CTMS_NOTIFICATIONS_REFRESH_EVENT = 'ctms-notifications-refresh';

export function dispatchNotificationsRefresh() {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(CTMS_NOTIFICATIONS_REFRESH_EVENT));
  }
}

export const VISIT_TYPES = {
  SSV: 'Site Selection Visit',
  SIV: 'Site Initiation Visit',
  SMV: 'Site Monitoring Visit',
  SCV: 'Site Close-Out Visit'
};

export const VISIT_STATUS = {
  DRAFT: 'Draft',
  PLANNED: 'Planned',
  CONFIRMED: 'Confirmed',
  ONGOING: 'Ongoing',
  COMPLETED: 'Completed',
  CANCELLED: 'Cancelled',
};

/** Fixed stage codes (same for all studies). Between 201 and 9999 studies may have multiple stages (301, 311, 321, etc.). */
export const STAGE_WORKFLOW = {
  SCHEDULE: 101,
  IN_PROGRESS: 201,
  COMPLETED: 9999,
};

/** Format visit for display as per spec: use DisplayVisitCode (e.g. SSV01). */
export function formatVisitId(visit) {
  if (!visit) return '—';
  const displayCode = (visit.displayVisitCode ?? visit.DisplayVisitCode ?? '').toString().trim();
  if (displayCode) return displayCode;
  const id = visit.scheduledVisitID ?? visit.scheduledVisitId ?? visit.ScheduledVisitID ?? 0;
  const type = (visit.visitType || visit.VisitType || 'SMV').toString().trim();
  // Backward-compatible fallback when DisplayVisitCode is not present (older API / pre-backfill).
  return `${type}${id}`;
}
